import type { Enums, WebfleetOrderState } from "../types";

export function getWebfleetOrderStateColor(state: WebfleetOrderState): Enums<"color"> {
	switch (state) {
		case 0:
			return "zinc"; // Not yet sent
		case 100:
			return "slate"; // Sent
		case 101:
			return "slate"; // Received
		case 102:
			return "slate"; // Read
		case 103:
			return "blue"; // Accepted

		case 201:
			return "sky"; // Service order started
		case 202:
			return "azure"; // Arrived at destination
		case 203:
			return "blue"; // Work started
		case 204:
			return "emerald"; // Work finished
		case 205:
			return "teal"; // Departed from destination
		case 207:
			return "emerald"; // Proof of delivery

		case 221:
			return "sky"; // Pickup order started
		case 222:
			return "azure"; // Arrived at pick up location
		case 223:
			return "blue"; // Pick up started
		case 224:
			return "emerald"; // Pick up finished
		case 225:
			return "teal"; // Departed from pick up location
		case 227:
			return "emerald"; // Proof of delivery

		case 241:
			return "sky"; // Delivery order started
		case 242:
			return "azure"; // Arrived at delivery location
		case 243:
			return "blue"; // Delivery started
		case 244:
			return "emerald"; // Delivery finished
		case 245:
			return "teal"; // Departed from delivery location
		case 247:
			return "accent"; // Proof of delivery

		case 298:
			return "amber"; // Resumed
		case 299:
			return "orange"; // Suspended

		case 301:
			return "rose"; // Cancelled
		case 302:
			return "rose"; // Rejected

		case 401:
			return "emerald"; // Finished
	}
}
